import React from 'react';

const AddedCouponMultiActionBtns = ({checkedArr}) => {
  return (
    <div>

    </div>
  );
};

export default AddedCouponMultiActionBtns;
